export const es = {
  // Navigation
  nav: {
    home: "Home",
    explore: "Explorar",
    myEvents: "Mis Eventos",
    profile: "Perfil",
  },

  // Auth
  auth: {
    signIn: "Iniciar Sesión",
    signUp: "Crear Cuenta",
    signingIn: "Iniciando sesión...",
    creatingAccount: "Creando cuenta...",
    email: "Email",
    emailPlaceholder: "tu@email.com",
    password: "Contraseña",
    passwordPlaceholder: "Tu contraseña",
    confirmPassword: "Confirmar Contraseña",
    confirmPasswordPlaceholder: "Repite tu contraseña",
    createSecurePassword: "Crea una contraseña segura",
    firstName: "Nombre",
    firstNamePlaceholder: "Tu nombre",
    lastName: "Apellido",
    lastNamePlaceholder: "Tu apellido",
    birthDate: "Fecha de Nacimiento",
    selectDate: "Selecciona fecha",
    gender: "Género",
    selectGender: "Selecciona tu género",
    male: "Masculino",
    female: "Femenino",
    preferNotToSay: "Prefiero no decir",
    phoneNumber: "Número de teléfono",
    phonePlaceholder: "123 456 7890",
    phoneTaken: "Teléfono ya registrado",
    phoneTakenDesc: "Este número de teléfono ya está asociado a otra cuenta.",
    phoneInvalid: "Teléfono inválido",
    phoneInvalidDesc: "El número debe tener exactamente 10 dígitos.",
    noAccount: "¿No tienes cuenta?",
    createHere: "Crea una aquí",
    haveAccount: "¿Ya tienes cuenta?",
    signInHere: "Inicia sesión aquí",
    or: "o",
    iAmJudge: "Soy Juez de Cancha",
    welcome: "¡Bienvenido!",
    accountCreated: "Tu cuenta ha sido creada.",
    signedIn: "Has iniciado sesión correctamente.",
    signUpError: "Error al registrarse",
    signInError: "Error al iniciar sesión",
    unexpectedError: "Ocurrió un error inesperado",
    weakPassword: "Contraseña débil",
    weakPasswordDesc: "La contraseña debe tener mínimo 8 caracteres, un número y un carácter especial.",
    passwordsMismatch: "Las contraseñas no coinciden",
    passwordsMismatchDesc: "Por favor verifica que ambas contraseñas sean iguales.",
    login: "Ingresar",
    ok: "OK",
  },

  // Common
  common: {
    loading: "Cargando...",
    error: "Error",
    save: "Guardar",
    cancel: "Cancelar",
    back: "Volver",
    search: "Buscar",
    all: "Todos",
    close: "Cerrar",
    confirm: "Confirmar",
    delete: "Eliminar",
    edit: "Editar",
    yes: "Sí",
    no: "No",
    free: "Gratis",
    register: "Inscribirse",
    registered: "Inscrito",
    share: "Compartir",
    details: "Detalles",
    viewMore: "Ver más",
    viewAll: "Ver todos",
    noResults: "Sin resultados",
    retry: "Reintentar",
    sport: "Deporte",
    location: "Ubicación",
    date: "Fecha",
    time: "Hora",
    category: "Categoría",
    participants: "Participantes",
    user: "Usuario",
  },

  // Dashboard / Home
  dashboard: {
    greeting: "¡Hola",
    loadingExperience: "Preparando tu experiencia...",
    featuredEvents: "Eventos Destacados",
    featuredOrganizers: "Organizadores Destacados",
    suggestedClubs: "Clubes Sugeridos",
    myUpcomingEvents: "Mis Próximos Eventos",
    tournaments: "Torneos",
    leagues: "Ligas",
    noUpcomingEvents: "No tienes eventos próximos",
    exploreEvents: "¡Explora eventos disponibles!",
    viewAllMyEvents: "Ver todos mis eventos",
  },

  // Explore
  explore: {
    tournaments: "Torneos",
    leagues: "Ligas",
    organizers: "Organizadores",
    players: "Jugadores",
    clubs: "Clubes",
    searchPlaceholder: "Buscar torneos por nombre, deporte o ubicación...",
    searchPlayers: "Buscar por nombre, email o ubicación...",
    searchOrganizers: "Buscar organizadores...",
    searchLeagues: "Buscar ligas por nombre, deporte o ubicación...",
    searchPlayersTitle: "Busca jugadores",
    searchPlayersHint: "Escribe al menos 2 caracteres para buscar por nombre o ubicación",
    noEventsFound: "No se encontraron eventos",
    noPlayersFound: "No se encontraron jugadores",
    noOrganizersFound: "No se encontraron organizadores",
    noLeaguesFound: "No se encontraron ligas",
    adjustSearch: "Intenta ajustar tu búsqueda",
    adjustSearchFilters: "Intenta ajustar tu búsqueda o filtros",
    loadingPlayers: "Cargando jugadores...",
    loadingLeagues: "Cargando ligas...",
    errorLoadingPlayers: "Error al cargar jugadores",
    viewProfile: "Ver perfil",
    eventsHeld: "eventos realizados",
    upcomingEvents: "próximos eventos",
    all: "Todos",
    filterByDistance: "Filtrar por distancia",
    distance: "Distancia",
    noLimit: "Sin límite",
    close: "Cercano",
    medium: "Medio",
    far: "Lejano",
    filters: "Filtros",
  },

  // Players
  players: {
    follow: "Seguir",
    following: "Lo sigues",
    friends: "Amigos",
    followBack: "Seguir de vuelta",
    sending: "Enviando...",
    nowFollowing: "Ahora sigues a",
    followError: "Error al seguir usuario",
  },

  // My Events
  myEventsPage: {
    upcoming: "Próximos",
    active: "Activos",
    finished: "Finalizados",
    noEvents: "No tienes eventos",
    noUpcoming: "No tienes eventos próximos",
    noActive: "No tienes eventos activos",
    noFinished: "No tienes eventos finalizados",
  },

  // Profile
  profile: {
    myProfile: "Mi Perfil",
    settings: "Configuración",
    editProfile: "Editar perfil",
    tournaments: "Torneos",
    followers: "Seguidores",
    following: "Siguiendo",
    recentActivity: "Actividad Reciente",
    friends: "Amigos",
    myEvents: "Mis Eventos",
    achievements: "Logros",
    idCopied: "ID copiado al portapapeles",
    idCopyError: "No se pudo copiar el ID",
    favoriteSports: "Deportes Favoritos",
    noActivity: "No hay actividad reciente",
    aboutMe: "Sobre mí",
    tournamentStats: "Estadísticas de Torneos",
    tournamentHistory: "Historial de Torneos",
    participation: "Participación",
    noTournamentHistory: "Aún no tienes historial de torneos",
    subcategoryLabel: "Subcategoría",
    quarterFinals: "Cuartos de Final",
    semiFinals: "Semifinal",
    runnerUp: "Subcampeón",
    champion: "Campeón",
    pts: "Pts",
    format: "Formato",
    circuit: "Circuito",
    blitz: "Relámpago",
    totalPoints: "Pts Totales",
    signInToSeeProfile: "Inicia sesión para ver tu perfil",
    loadingProfile: "Cargando perfil...",
    eventHistory: "Historial de Eventos",
    noEvents: "No tienes eventos",
    noEventsRegistered: "Sin eventos registrados",
    registerFirst: "¡Regístrate en tu primer torneo o liga!",
    noEventsOther: "Este usuario aún no ha participado en eventos",
    exploreEvents: "Explorar Eventos",
    viewAllEvents: "Ver Todos los Eventos",
    eventsLabel: "eventos",
    viewLess: "Ver menos",
    review: "Evaluar",
    reviewed: "Evaluado",
    reviewOrganizer: "Evaluar organizador",
    optionalComment: "Comentario opcional...",
    submit: "Enviar",
    submitting: "Enviando...",
    add: "Agregar",
    searchFriends: "Buscar Amigos",
    searchByName: "Buscar por nombre...",
    friend: "Amigo",
    pending: "Pendiente",
    noFriendsYet: "No tienes amigos todavía",
    searchAndFollow: "¡Busca y sigue algunos usuarios!",
    chatStarted: "Chat iniciado",
    level: "Nivel",
    challenge: "Retar",
    networkStats: "Estadísticas de Red",
    requests: "Solicitudes",
    athletes: "Deportistas",
    loadingFriends: "Cargando amigos...",
    followError: "Error al seguir usuario",
    nowFollowing: "Ahora sigues a este usuario",
    statusActive: "En Curso",
    statusUpcoming: "Próximo",
    statusFinished: "Finalizado",
    total: "total",
    back: "Volver",
    loading: "Cargando...",
    profileNotFound: "Perfil no encontrado",
    userNotAvailable: "Este usuario no existe o no está disponible.",
    backToHome: "Volver al inicio",
    memberSince: "Miembro desde",
    noLocation: "Sin ubicación",
    mutualFriends: "Amigos",
    follow: "Seguir",
    followBackLabel: "Seguir de vuelta",
    message: "Mensaje",
    aboutUser: "Sobre",
    thisUser: "este usuario",
    statistics: "Estadísticas",
    ranking: "Ranking",
    myCircuits: "Mis Circuitos",
    position: "Posición",
    noRankings: "Aún no tienes ranking en ningún circuito",
    noRankingsDesc: "Inscríbete a un torneo para empezar a acumular puntos",
    tournamentsPlayed: "Torneos jugados",
    viewCircuit: "Ver circuito",
  },

  // Settings
  settings: {
    title: "Configuración",
    personal: "Personal",
    notifications: "Alertas",
    privacy: "Privacidad",
    account: "Cuenta",
    support: "Soporte",
    language: "Idioma",
    fullName: "Nombre completo",
    bio: "Biografía",
    locationLabel: "Ubicación",
    phone: "Teléfono",
    skillLevel: "Nivel de juego",
    preferredSports: "Deportes preferidos",
    saveChanges: "Guardar Cambios",
    saving: "Guardando...",
    savedSuccess: "Perfil actualizado correctamente",
    savedError: "Error al actualizar el perfil",
    emailNotifications: "Notificaciones por email",
    eventReminders: "Recordatorios de eventos",
    friendRequests: "Solicitudes de amistad",
    profileVisibility: "Visibilidad del perfil",
    public: "Público",
    friendsOnly: "Solo amigos",
    private: "Privado",
    showActivity: "Mostrar actividad",
    changePassword: "Cambiar contraseña",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    confirmNewPassword: "Confirmar nueva contraseña",
    passwordChanged: "Contraseña actualizada correctamente",
    passwordChangeError: "Error al cambiar la contraseña",
    signOut: "Cerrar sesión",
    downloadData: "Descargar mis datos",
    downloading: "Descargando...",
    deleteAccount: "Eliminar mi cuenta",
    deleteAccountWarning: "Esta acción es irreversible",
    helpCenter: "Centro de ayuda",
    termsOfService: "Términos de servicio",
    privacyPolicy: "Política de privacidad",
    contactUs: "Contáctanos",
    version: "Versión",
  },

  // Events
  events: {
    tournament: "Torneo",
    league: "Liga",
    registrationFee: "Inscripción",
    registrationDeadline: "Cierre de inscripción",
    maxParticipants: "Cupos",
    format: "Formato",
    matchType: "Modalidad",
    singles: "Singles",
    doubles: "Dobles",
    both: "Ambos",
    roundRobin: "Round Robin",
    elimination: "Eliminación Directa",
    sumGames: "Sumatoria de Juegos",
    ladder: "Escalera/Piramidal",
    rules: "Reglamento",
    prizes: "Premios",
    schedule: "Calendario",
    standings: "Posiciones",
    bracket: "Llaves",
    groups: "Grupos",
    myGroup: "Mi Grupo",
    allGroups: "Todos los Grupos",
    matches: "Partidos",
    results: "Resultados",
    info: "Info",
    startDate: "Inicio",
    endDate: "Fin",
    organizedBy: "Organizado por",
    available: "disponibles",
    spotsLeft: "lugares restantes",
    eventFull: "Evento lleno",
    registrationClosed: "Inscripciones cerradas",
    alreadyRegistered: "Ya estás inscrito",
    guaranteedMatches: "Partidos garantizados",
    setsPerMatch: "Sets por partido",
    goldenPoint: "Punto de oro",
    superTieBreak: "Super tie-break",
    gamesPerSet: "Juegos por set",
    upcoming: "Próximo",
    perPerson: "por persona",
    perPair: "por pareja",
    perPersonPair: "por persona/pareja",
    byOrganizer: "por",
    deadline: "Límite",
    closed: "Cerrado",
    lastDay: "¡Último día!",
    dayLeft: "día",
    daysLeft: "días",
    viewPrizes: "Ver Premios",
    noFeaturedEvents: "No hay eventos destacados de",
    exploreAllEvents: "Explora todos los eventos para encontrar opciones de",
    viewAllEvents: "Ver todos los eventos",
    popularUpcoming: "Próximos torneos y ligas populares",
    encounters: "encuentros",
    nextEncounter: "Próximo encuentro",
    encounter: "Encuentro",
    opponent: "Oponente",
    court: "Cancha",
    groupsPending: "Grupos pendientes de asignación",
    matchesPending: "Partidos pendientes de programación",
    tapForDetails: "Toca para ver detalles",
    yourNextEvent: "Tu próximo evento",
    yourNextEvents: "Tus próximos eventos",
    loadingEvents: "Cargando eventos...",
    noTournamentsFound: "No se encontraron torneos",
    adjustSearch: "Intenta ajustar tu búsqueda o filtros",
    filterByDistance: "Filtrar por distancia",
    singlesAndDoubles: "Singles y Dobles",
  },

  // Judge
  judge: {
    title: "Acceso de Juez",
    enterCode: "Ingresa tu código de acceso",
    codePlaceholder: "Código de 6 dígitos",
    codeError: "El código debe tener 6 caracteres",
    validate: "Validar",
    validating: "Validando...",
    pending: "Pendientes",
    completed: "Completados",
    court: "Cancha",
    match: "Partido",
    vs: "vs",
    assignScore: "Asignar Puntaje",
    noMatches: "No hay partidos",
    noPendingMatches: "No hay partidos pendientes",
    noCompletedMatches: "No hay partidos completados",
    day: "Día",
    allDays: "Todos",
    phase: "Fase",
    group: "Grupo",
    refreshMatches: "Actualizar partidos",
    expandAll: "Expandir todo",
    collapseAll: "Colapsar todo",
    backToLogin: "Volver al inicio",
    tournamentOf: "Torneo de",
    welcomeJudge: "Bienvenido, Juez",
  },

  // Notifications
  notifications: {
    title: "Notificaciones",
    chats: "Chats",
    noNotifications: "No tienes notificaciones",
    markAllRead: "Marcar todas como leídas",
    newMessage: "Nuevo mensaje",
    subtitle: "Mantente al día con las últimas actualizaciones",
    chatsSubtitle: "Tus conversaciones activas",
    noNotificationsTitle: "No hay notificaciones",
    noNotificationsDesc: "Te notificaremos cuando haya actualizaciones importantes",
    deleted: "Notificación eliminada",
    allDeleted: "Todas las notificaciones eliminadas",
    chatDeleted: "Conversación eliminada",
    chatDeleteError: "Error al eliminar la conversación",
    chatStartError: "Error al iniciar conversación",
    followedBack: "Has comenzado a seguir a este usuario",
    followBackError: "Error al seguir de vuelta",
    processError: "No se pudo procesar la notificación",
    viewProfile: "Ver perfil",
    followBack: "Seguir de vuelta",
    reject: "Rechazar",
    register: "Inscribirme",
    newConversation: "Nueva conversación",
    tabAll: "Todos",
    tabFriends: "Amigos",
    tabOrganizers: "Organizadores",
    noChatsAll: "No hay conversaciones",
    noChatsAllDesc: "Tus chats con otros jugadores y clubes aparecerán aquí",
    noChatsFriends: "No hay conversaciones con amigos",
    noChatsFriendsDesc: "Tus chats con amigos aparecerán aquí",
    noChatsOrganizers: "No hay conversaciones con organizadores",
    noChatsOrganizersDesc: "Tus chats con organizadores de eventos aparecerán aquí",
    noMessages: "Sin mensajes",
    timeNow: "Ahora",
    timeMinAgo: "Hace {n} min",
    timeHoursAgo: "Hace {n}h",
    timeDaysAgo: "Hace {n}d",
    searchContact: "Buscar contacto...",
    noContactsAvailable: "No tienes contactos disponibles.",
    noContactsHint: "Sigue a otros jugadores o inscríbete a eventos para chatear con organizadores.",
    noContactsFound: "No se encontraron contactos para",
  },

  // Registration
  registration: {
    title: "Inscripción",
    step: "Paso",
    of: "de",
    personalData: "Datos personales",
    payment: "Pago",
    confirmation: "Confirmación",
    selectCategory: "Selecciona categoría",
    selectSubcategory: "Selecciona subcategoría",
    partner: "Pareja",
    selectPartner: "Seleccionar pareja",
    invitePartner: "Invitar pareja",
    noPartner: "Sin pareja (se asignará una)",
    payNow: "Pagar ahora",
    payLater: "Pagar después",
    registrationComplete: "¡Inscripción completada!",
    registrationError: "Error al inscribirse",
    accessCode: "Código de acceso",
    accessCodeEntry: {
      title: "Ingresar Código de Acceso",
      description: "Ingresa el código de 6 caracteres que te proporcionó el organizador",
      verifyButton: "Verificar Código",
      verifying: "Verificando...",
      footerNote: "El código fue generado cuando el organizador te inscribió manualmente",
      registrationFound: "¡Inscripción encontrada!",
      event: "Evento",
      category: "Categoría",
      players: "Jugadores",
      you: "Tú",
      claimButton: "Reclamar mi inscripción",
      claiming: "Reclamando inscripción...",
      useAnotherCode: "Usar otro código",
    },
    progressSteps: {
      participant: "Participante",
      participantDesc: "Modalidad y participantes",
      payment: "Pago",
      paymentDesc: "Información de pago",
      confirmation: "Confirmación",
      confirmationDesc: "Resumen final",
    },
    page: {
      loading: "Cargando evento...",
      notFound: "Evento no encontrado",
      backToHome: "Volver al inicio",
      back: "Volver",
      registrationTo: "Inscripción a",
      league: "Liga",
      tournament: "Torneo",
    },
    dataStep: {
      title: "Datos de Inscripción",
      descriptionLeague: "Completa la información para inscribirte a la liga",
      descriptionTournament: "Completa la información para inscribirte al torneo",
      modality: "Modalidad",
      singlesLabel: "Singles (Individual)",
      singlesOnlyLeague: "Esta liga es solo individual",
      singlesOnlyTournament: "Este torneo es solo individual",
      doublesLabel: "Dobles (Parejas)",
      doublesOnlyLeague: "Esta liga es solo de parejas, necesitarás un compañero",
      doublesOnlyTournament: "Este torneo es solo de parejas, necesitarás un compañero",
      category: "Categoría",
      categoryOfLeague: "Categoría de esta liga",
      categoryOfTournament: "Categoría de este torneo",
      selectCategory: "Selecciona una categoría",
      subcategory: "Subcategoría",
      subcategoryOfLeague: "Subcategoría de esta liga",
      subcategoryOfTournament: "Subcategoría de este torneo",
      selectSubcategory: "Selecciona una subcategoría",
      full: "LLENO",
      available: "disponibles",
      enrolled: "inscrito",
      enrolledPlural: "inscritos",
      loadingAvailability: "Cargando disponibilidad...",
      spotsAvailable: "Cupos disponibles en",
      pair: "pareja",
      pairs: "parejas",
      lastSpots: "Últimos cupos",
      spotsFull: "Cupos agotados en",
      playerNames: "Nombres de los Jugadores",
      playerName: "Nombre del Jugador",
      player1: "Jugador 1",
      fullName: "Nombre completo",
      enterFullName: "Ingresa tu nombre completo",
      howAddPartner: "¿Cómo quieres agregar a tu compañero?",
      manualEntry: "Ingresar nombre manualmente",
      selectFromFriends: "Seleccionar de mis amigos",
      partnerName: "Nombre del compañero/a",
      enterPartnerName: "Ingresa el nombre de tu compañero/a",
      payBothNote: "Serás responsable de pagar la inscripción completa por ambos",
      searchFriend: "Buscar amigo",
      fullPayment: "Pago completo",
      fullPaymentNote: "Pagarás la inscripción completa por ti y por",
      fullPaymentDesc: "Pagas la inscripción completa por ti y por",
      partnerDefault: "tu compañero",
      invitationNote: "Se le enviará una invitación para que confirme su participación.",
      paymentModeLabel: "¿Cómo prefieres pagar?",
      splitPaymentLabel: "Pago separado",
      each: "c/u",
      splitPaymentDesc: "Pagas tu mitad ahora.",
      splitPaymentHours: "tendrá {hours} horas para pagar su parte.",
      splitNotAvailable: "No disponible — el evento está demasiado cerca para usar pago separado.",
      back: "Volver",
      spotsExhausted: "Cupos Agotados en esta Subcategoría",
      continue: "Continuar",
      promo: {
        title: "Cupón promocional",
        placeholder: "Ingresa tu código",
        apply: "Aplicar",
        applying: "Validando...",
        valid: "Descuento",
        invalid: "Código inválido o no disponible para este evento",
        expired: "Este código ha alcanzado su límite de usos",
        savings: "Ahorro",
        remove: "Quitar",
      },
    },
  },

  // Payment
  payment: {
    title: "Pago",
    processing: "Procesando pago...",
    success: "¡Pago exitoso!",
    error: "Error en el pago",
    amount: "Monto",
    method: "Método de pago",
    card: "Tarjeta",
    transfer: "Transferencia",
    paymentInfo: "Información de Pago",
    completePayment: "Completa el pago para finalizar tu inscripción",
    registrationSummary: "Resumen de Inscripción",
    event: "Evento",
    modality: "Modalidad",
    singles: "Singles",
    doubles: "Dobles",
    category: "Categoría",
    subcategory: "Subcategoría",
    player1: "Jugador 1",
    partner: "Compañero",
    paymentType: "Tipo de pago",
    fullPayment: "Pago completo",
    totalToPay: "Total a pagar",
    doublesNote: "Incluye inscripción completa para ambos jugadores. Se enviará invitación a tu compañero.",
    paymentMethod: "Método de Pago",
    backToData: "Volver a Datos",
    paymentProcess: "Proceso de Pago",
    completeRegistration: "Completa tu inscripción",
    back: "Volver",
    paymentSummary: "Resumen del Pago",
    participants: "Participantes",
    currentUser: "Usuario Actual",
    pair: "Pareja",
    eventInfo: "Información del Evento",
    location: "Ubicación",
    date: "Fecha",
    time: "Hora",
    sport: "Deporte",
    individual: "Individual",
    pairs: "Parejas",
    format: "Formato",
    league: "Liga",
    tournament: "Torneo",
    organizer: "Organizador",
    deadline: "Fecha límite",
    prizes: "Premios",
    prizesAvailable: "premios disponibles",
    paymentMode: "Modalidad de Pago",
    splitPayment: "Pago dividido",
    partnerPayNotice: "Se enviará notificación a tu pareja para completar el pago",
    partnerPayHalf: "Tu compañero pagará la otra mitad por separado",
    secureStripe: "Pago seguro con Stripe",
    redirectNotice: "Serás redirigido a una página de pago segura para completar tu transacción",
    sslNotice: "Tu información de pago está protegida con encriptación SSL de nivel bancario",
    creatingSession: "Creando sesión de pago...",
    proceedPayment: "Proceder al Pago",
    openingWindow: "Se abrirá una nueva ventana con la página de pago segura de Stripe",
    termsNotice: "Al confirmar el pago, aceptas los términos y condiciones del evento y la política de cancelación.",
    openingPaymentPage: "Abriendo página de pago...",
    openingStripePage: "Abriendo página de pago de Stripe...",
    errorCreatingSession: "Error al crear la sesión de pago",
    noPaymentUrl: "No se recibió la URL de pago",
    errorProcessing: "Error al procesar el pago",
    sumatoriaJuegos: "Sumatoria de Juegos",
    escaleraFormat: "Escalera (Formato Piramidal)",
    directElimination: "Eliminación Directa",
    roundRobin: "Round Robin",
    installments: "Meses sin Intereses (MSI)",
    payInFull: "Pago de contado",
    months3: "3 meses sin intereses",
    months6: "6 meses sin intereses",
    months9: "9 meses sin intereses",
    months12: "12 meses sin intereses",
    msiNote: "Solo aplica para tarjetas de crédito mexicanas. Stripe mostrará las opciones disponibles según tu tarjeta.",
    msiAvailable: "Meses sin intereses disponible",
    selectPlan: "Selecciona un plan de pago",
    yourPart: "Tu parte",
    splitPaymentNote: "Se retendrá tu pago hasta que {name} complete su parte. Si no paga a tiempo, tu cargo será liberado.",
    splitInfoBanner: "Tu pago será retenido temporalmente. Cuando {name} pague su mitad, ambos pagos se procesarán y la inscripción quedará confirmada.",
  },

  // Dates
  dates: {
    today: "¡Hoy!",
    tomorrow: "Mañana",
    yesterday: "Ayer",
    days: "días",
    day: "día",
    hours: "horas",
    hour: "hora",
    minutes: "minutos",
    min: "min",
    ago: "hace",
    in: "en",
    thisWeek: "Esta semana",
  },

  // Sports
  sports: {
    padel: "Pádel",
    tennis: "Tenis",
    pickleball: "Pickleball",
  },

  // Skill levels
  levels: {
    beginner: "Principiante",
    intermediate: "Intermedio",
    advanced: "Avanzado",
    professional: "Profesional",
  },
  categories: {
    masculino: "Masculino",
    femenino: "Femenino",
    mixto: "Mixto",
  },
  subcategories: {
    "1era": "1era",
    "2nda": "2nda",
    "3era": "3era",
    "4ta": "4ta",
    "5ta": "5ta",
    "6ta": "6ta",
  },
  prizes: {
    title: "Premios",
    titleWithEvent: "Premios - {event}",
    firstPlace: "Primer Lugar",
    secondPlace: "Segundo Lugar",
    noPrizes: "No hay información de premios disponible para este evento.",
    trophy: "Trofeo",
    paddle: "Pala",
    racket: "Raqueta",
    certificate: "Certificado",
    otherPrize: "Otro premio",
    prize: "Premio",
  },

  // Event Detail / Registration Form
  eventDetail: {
    organizer: "Organizador",
    registrationDeadline: "Fecha límite de inscripción",
    guaranteedMatches: "Partidos asegurados",
    categories: "Categorías",
    modality: "Modalidad",
    price: "Precio",
    perPerson: "por persona",
    perPair: "por pareja",
    perParticipation: "por participación",
    perPersonPair: "por persona/pareja",
    viewPrizes: "Ver Premios",
    format: "Formato",
    encounters: "Encuentros",
    matches: "partidos",
    registrationsClosed: "Inscripciones cerradas",
    daysLeft: "días restantes",
    dayLeft: "día restante",
    signMeUp: "¡Inscríbeme!",
    tournamentFull: "Torneo Lleno",
    leagueFull: "Liga Llena",
    accessCode: "¿Tienes un código de acceso?",
    contactOrganizer: "Contactar al organizador",
    gameCalendar: "Calendario de Fechas de Juego",
    weeks: "semanas",
    swipeMore: "Desliza para ver más semanas →",
    eliminationPhase: "Fase Eliminatoria",
    eliminationDesc: "Los mejores clasificados de la fase regular accederán a los playoffs para definir al campeón.",
    bookEncounter: "Reserva tu encuentro (Lunes-Domingo)",
    noCategories: "Sin categorías configuradas",
    pairs: "parejas",
    registered: "inscritos",
    linkCopied: "Enlace copiado al portapapeles",
    organizerNotFound: "No se encontró el organizador",
    chatError: "No se pudo iniciar el chat",
  },

  // League Details
  league: {
    organizer: "Organizador",
    prizes: "Premios",
    rules: "Reglas",
    gameRules: "Reglas del Juego",
    format: "Formato",
    category: "Categoría",
    subcategory: "Subcategoría",
    partner: "Compañero",
    roundRobin: "Round Robin",
    sumatoria: "Sumatoria",
    sumatoriaDeJuegos: "Sumatoria de Juegos",
    escalera: "Escalera",
    escaleraLabel: "Escalera Piramidal",
    leagueCalendar: "Calendario de la Liga",
    encounter: "Encuentro",
    week: "Semana",
    rest: "Descanso",
    willYouAttend: "¿Asistirás?",
    confirmAttendance: "¿Confirmas asistencia?",
    willAttend: "Asistiré",
    wontAttend: "No asistiré",
    regularPhase: "Fase Regular",
    regular: "Regular",
    elimination: "Eliminación",
    eliminationPhase: "Fase de Eliminación",
    totalEncounters: "Total Encuentros",
    encountersLabel: "Encuentros",
    past: "Pasadas",
    current: "Actual",
    future: "Futuras",
    eliminationPhases: "Fases de Eliminación",
    eliminationStructure: "Estructura de Eliminación",
    eliminationSchedule: "Horarios de Eliminación",
    autoClassification: "Clasificación Automática",
    classifyTop: "Los primeros {count} lugares de la fase regular clasifican automáticamente",
    octavos: "Octavos",
    cuartos: "Cuartos",
    semifinales: "Semifinales",
    final: "Final",
    standings: "Tabla de Posiciones",
    podium: "Podio",
    you: "TÚ",
    wins: "Victorias",
    losses: "Derrotas",
    setsFor: "Sets AF",
    setsAgainst: "Sets EC",
    gamesFor: "Juegos AF",
    gamesAgainst: "Juegos EC",
    difference: "Diferencia",
    points: "Pts",
    pos: "Pos",
    pair: "Pareja",
    player: "Jugador",
    systemRoundRobin: "Sistema: 3 puntos por victoria, 0 por derrota",
    tiebreakRoundRobin: "Desempate: 1) Partidos ganados 2) Diferencia de sets 3) Diferencia de juegos",
    systemSumatoria: "Sistema: Total de juegos sumados",
    tiebreakSumatoria: "Desempate: 1) Juegos a favor 2) Diferencia",
    toBeConfirmed: "Por confirmar",
    next: "Próxima",
    completed: "Completada",
    // Game rules labels
    gameFormat: "Formato de Juego",
    setTiebreak: "Desempate de Set",
    goldenPoint: "Punto de Oro",
    thirdSet: "Tercer Set",
    matchesPerDay: "Partidos por Día",
    objective: "Objetivo",
    tiebreak: "Desempate",
    bestOf3Sets: "Mejor de 2 de 3 sets",
    tiebreakAt66: "Tie-break a 7 puntos en 6-6",
    yesAt4040: "Sí en 40-40",
    superTiebreak10: "Súper Tie-break a 10 puntos",
    twentyMinMatches: "Partidos de 20 minutos",
    threeMatchesPerDay: "3 partidos por día de liga",
    sumMostGames: "Sumar la mayor cantidad de juegos",
    tiebreakDifference: "Mayor diferencia J.Favor - J.Contra",
    // Escalera specific
    challengeFormat: "Formato de Retos",
    challengeResult: "Resultado",
    challengeEncounters: "Encuentros",
    challengePlayoff: "Playoff",
    challengeSimple: "Reta 1 posición arriba",
    challengeDouble: "Reta 1 o 2 posiciones arriba",
    pairChallenge: "Las parejas por cancha se retan entre sí",
    winnerGoesUp: "Ganador sube y perdedor baja de cancha",
    winnerTakesPosition: "Ganador toma la posición más alta",
    alwaysEncounters: "Siempre se juegan encuentros entre parejas",
    top4Classify: "Top 4 clasifican a eliminatorias finales",
    topCourtLabel: "Cancha de Mayor Nivel",
    middleCourtLabel: "Cancha Intermedia",
    rotatingPartners: "Compañeros Rotativos",
    resultWeek: "Resultado Semana",
    yourChallenge: "Tu Reto - Semana",
    // Sumatoria specific
    weekSummary: "Resumen de la Semana",
    gamesAdded: "Juegos Sumados",
    gamesAgainstLabel: "Juegos en Contra",
    swipeMoreMatches: "Desliza para ver más partidos",
    matchLabel: "Partido",
    courtLabel: "Cancha",
    toPlay: "Por jugar",
    seasonInProgress: "Temporada en curso",
    aboutToStart: "Próximo a iniciar",
    // Court booking
    bookCourt: "Reservar Cancha",
    oneBookingPerWeek: "1 reserva por semana",
    loadingAvailability: "Cargando disponibilidad...",
    restWeekLabel: "Semana de descanso",
    noMatchesThisWeek: "No hay partidos programados esta semana",
    noSlotsAvailable: "Sin horarios establecidos para esta semana",
    yourBooking: "Tu reserva",
    cancel: "Cancelar",
    allSlotsBooked: "Todos los horarios están reservados",
    availableSlots: "Horarios disponibles:",
    booked: "Reservado",
    available: "Disponible",
    register: "Inscríbete",
    book: "Reservar",
    days: {
      monday: "Lunes",
      tuesday: "Martes",
      wednesday: "Miércoles",
      thursday: "Jueves",
      friday: "Viernes",
      saturday: "Sábado",
      sunday: "Domingo",
    },
    dayAbbr: {
      mon: "L",
      tue: "M",
      wed: "Mi",
      thu: "J",
      fri: "V",
      sat: "S",
      sun: "D",
    },
    // Encounter selector & status badges
    selectEncounter: "Seleccionar encuentro",
    encounterLabel: "Encuentro",
    restWeekNum: "Descanso (Semana {n})",
    roundOf16: "Octavos de Final",
    quarterFinals: "Cuartos de Final",
    semiFinals: "Semifinales",
    restWeekTitle: "Semana de descanso",
    noMatchThisWeek: "No hay encuentro programado esta semana.",
    loading: "Cargando",
    completedStatus: "Completado",
    scheduledStatus: "Programado",
    toSchedule: "Por programar",
    inProgress: "En progreso",
    waitingStatus: "En espera",
    oddsVsEvens: "Impares vs Pares",
    evensVsOdds: "Pares vs Impares",
    positionRange: "Rango de {n} posiciones",
    positionRangeGeneric: "Rango de posiciones",
    loadingElimination: "Cargando partidos de eliminación...",
    notAssigned: "Aún no asignado",
    loadingChallenges: "Cargando retos...",
    noChallenge: "Sin reto asignado",
    noChallengeDesc: "No tienes un reto asignado para esta semana.",
    waitingResults: "Esperando resultados del Encuentro {n}",
    waitingResultsDesc: "Los enfrentamientos de este encuentro se determinarán una vez se complete el encuentro anterior.",
    encounterToSchedule: "Encuentro por programar",
    encounterToScheduleDesc: "Este encuentro aún no tiene partidos asignados.",
    noMatchesAssigned: "Sin partidos asignados",
    noMatchesAssignedDesc: "No tienes partidos programados para este encuentro.",
    loadingMatches: "Cargando partidos...",
    yourMatch: "Tu partido",
    matchResult: "Resultado del Encuentro",
    yourChallengeTitle: "Tu Reto",
    matchOfTheWeek: "Partido de la Semana",
    upcomingMatch: "Próximo partido programado",
    won: "Ganaste",
    lost: "Perdiste",
    pendingResult: "Pendiente",
    yourChallengeWeek: "Tu Reto - Semana {n}",
    challenger: "Retador",
    challenged: "Retado",
    youLabel: "TÚ",
    attendanceConfirmed: "Tu asistencia confirmada",
    attendanceDeclined: "Has indicado que no asistirás",
    confirmYourAttendance: "Confirma tu asistencia",
    opponentConfirmed: "Asistencia oponente confirmada",
    opponentDeclined: "Oponente no asistirá",
    opponentPending: "Asistencia oponente pendiente",
    currentLabel: "Actual",
    // Ranking section
    leagueRanking: "Ranking de la Liga",
    viewRanking: "Ver ranking",
    initialRanking: "Ranking Inicial",
    movement: "Movimiento",
    noRankingData: "No hay datos de ranking disponibles",
    maintains: "Mantiene",
    pendingMovement: "Pendiente",
  },

  // Format Info Dialog
  formatInfo: {
    features: "Características:",
    matchConfig: "Configuración de Partidos",
    setsPerMatch: "Sets por partido:",
    gamesPerSet: "Juegos por set:",
    goldenPointOn: "Golden Point activado",
    goldenPointOff: "Golden Point: No",
    superTiebreakOn: "Super Tiebreak activado",
    superTiebreakOff: "Super Tiebreak: No",
    gameTiming: "Tiempos de Juego",
    warmup: "Calentamiento:",
    restBetweenSets: "Descanso entre sets:",
    sideChange: "Cambio de lado:",
    minutes: "minutos",
    seconds: "segundos",
    scheduleAndDays: "Horarios y Días",
    gameDays: "Días de juego:",
    schedule: "Horario:",
    to: "a",
    conduct: "Normas",
    arrivalTolerance: "Tolerancia de llegada:",
    roundRobin: {
      title: "Formato Round Robin (Todos contra Todos)",
      description: "En este formato, cada participante se enfrenta contra todos los demás participantes del grupo. El ganador se determina por el mayor número de victorias o puntos acumulados.",
      features: ["Todos los equipos juegan entre sí al menos una vez", "Garantiza un número mínimo de partidos para todos", "El ranking se determina por victorias totales", "Ideal para conocer el nivel real de cada participante"],
      advantage: "Este formato garantiza que todos los participantes tengan múltiples oportunidades de jugar y competir.",
    },
    sumatoria: {
      title: "Formato Sumatoria de Juegos",
      description: "Similar al Round Robin, pero el ranking se determina por la suma total de juegos ganados en todos los partidos, no solo por victorias.",
      features: ["Todos juegan contra todos", "Se cuentan TODOS los juegos ganados", "Ejemplo: ganar 6-4, 6-3 suma 12 juegos", "Recompensa el rendimiento consistente"],
      advantage: "Este sistema valora cada juego ganado, haciendo que cada punto cuente para el resultado final.",
    },
    escalera: {
      title: "Formato Escalera (Pirámide)",
      description: "Los jugadores se organizan en niveles jerárquicos. Puedes desafiar a jugadores del nivel superior. Si ganas, intercambias posiciones. El objetivo es llegar a la cima de la escalera.",
      features: ["Organización en niveles o posiciones", "Puedes desafiar jugadores superiores (normalmente hasta 2 posiciones arriba)", "Si ganas el desafío, intercambias posiciones", "Horarios flexibles - los jugadores coordinan sus partidos"],
      advantage: "Formato ideal para ligas largas con flexibilidad de horarios, donde los jugadores pueden programar sus propios partidos.",
      specialFeatures: "Características Especiales de Escalera",
      scheduledOn: "Partidos programados los:",
      dateFlexibility: "Flexibilidad de fechas:",
      dateFlexibilityDesc: "Los jugadores pueden programar sus partidos en cualquier día acordado",
      directCoordination: "Coordinación directa",
      directCoordinationDesc: "entre jugadores para programar partidos",
    },
    doublesEscalera: {
      title: "Formato Escalera - Rey de la Cancha",
      description: "En este formato las parejas compiten en encuentros organizados por cancha. El número de cancha representa tu posición en el ranking. Las parejas de cada cancha se enfrentan y el ganador sube de cancha mientras el perdedor baja.",
      features: ["Las parejas se enfrentan por cancha en cada encuentro", "El ranking se refleja en el número de cancha asignada", "El ganador del encuentro sube a una cancha superior", "El perdedor baja a una cancha inferior", "Siempre se juegan encuentros, nunca hay semana sin competencia", "El objetivo es llegar y mantenerse en la Cancha 1"],
      advantage: "Este formato garantiza competencia constante entre parejas, donde cada encuentro define tu posición en el ranking de canchas.",
      systemTitle: "Sistema de Encuentros por Cancha",
      systemDesc: "En cada encuentro, las parejas asignadas a la misma cancha se enfrentan. El <strong>número de cancha define tu ranking</strong>: Cancha 1 es la posición más alta. Siempre hay encuentros programados.",
      winnerUp: "Ganador = Sube de cancha",
      loserDown: "Perdedor = Baja de cancha",
    },
    padelSingles: {
      title: "Formato Escalera de Pádel (Individual)",
      description: "En este formato dinámico, los jugadores individuales se enfrentan en canchas organizadas jerárquicamente. Cada encuentro te asigna una pareja diferente, fomentando la competencia individual mientras disfrutas del pádel en dobles.",
      features: ["En cada encuentro se te asigna una pareja aleatoria o rotativa", "Las canchas están organizadas de menor a mayor nivel", "El mejor jugador de cada cancha SUBE a la cancha superior", "El jugador con menor rendimiento BAJA a la cancha inferior", "El objetivo es llegar y mantenerse en la cancha principal", "Ideal para conocer diferentes compañeros mientras compites"],
      advantage: "Este formato combina la competencia individual con la experiencia del pádel en parejas, permitiéndote conocer diferentes estilos de juego mientras compites por ascender en la clasificación.",
      systemTitle: "Sistema de Rotación de Parejas",
      systemDesc: "En cada encuentro jugarás con una <strong>pareja diferente</strong>. Esto te permite conocer diversos estilos de juego y adaptarte a distintos compañeros mientras compites de forma individual.",
      bestUp: "Mejor = Sube de cancha",
      worstDown: "Menor rendimiento = Baja",
    },
    elimination: {
      title: "Formato Eliminación Directa",
      description: "Formato de copa o knockout tradicional. Si pierdes un partido, quedas eliminado del torneo. El último jugador o equipo sin derrotas es el campeón.",
      features: ["Un solo partido elimina al perdedor", "Estructura de llaves eliminatorias", "Rondas: Inicial → Octavos → Cuartos → Semifinales → Final", "Alta emoción en cada partido"],
      advantage: "Máxima tensión competitiva donde cada partido es decisivo para seguir en el torneo.",
    },
    default: {
      description: "Formato de competición personalizado.",
      features: ["Formato específico del evento", "Consulta con el organizador para más detalles"],
    },
  },

  // Organizer Profile
  organizerProfile: {
    loading: "Cargando perfil del organizador...",
    title: "Perfil del Organizador",
    notFound: "No se encontró el organizador",
    back: "Volver",
    tournaments: "Torneos",
    leagues: "Ligas",
    aboutOrganizer: "Acerca del organizador",
    showMore: "Ver más",
    showLess: "Ver menos",
    website: "Sitio web",
    upcomingEvents: "Próximos Eventos",
    noUpcomingTournaments: "No hay torneos próximos",
    noUpcomingLeagues: "No hay ligas próximas",
    reviewsAndRatings: "Reseñas y Calificaciones",
    review: "reseña",
    reviews: "reseñas",
    noReviewsYet: "Aún no hay reseñas",
    loginToRate: "Inicia sesión para calificar a este organizador",
    yourRating: "Tu calificación",
    edit: "Editar",
    editRating: "Editar tu calificación",
    rateOrganizer: "Calificar organizador",
    optionalComment: "Comentario opcional...",
    submitting: "Enviando...",
    submit: "Enviar",
    cancel: "Cancelar",
    photos: "Fotos",
    noPhotos: "El organizador aún no ha publicado fotos",
    follow: "Seguir",
    following: "Siguiendo",
    unfollow: "Dejar de seguir",
    followers: "Seguidores",
    follower: "Seguidor",
    sponsors: "Patrocinadores Oficiales",
    shareProfile: "Compartir Perfil",
    profileCopied: "Link del perfil copiado",
    upcoming: "Próximos",
    past: "Pasados",
    ranking: "Ranking",
    noRankingData: "No hay datos de ranking disponibles",
    sport: "Deporte",
    category: "Categoría",
    subcategory: "Subcategoría",
    player: "Jugador",
    points: "Pts",
    championships: "Campeonatos",
    finalist: "Finalista",
    registerToSeeRanking: "Aún no tienes ranking en este circuito. Inscríbete a un torneo para empezar",
  },

  // Tournament
  tournament: {
    groupPhase: "Fase de Grupos",
    eliminationPhase: "Fase de Eliminación",
    eliminationDirect: "Eliminación Directa",
    sumOfGames: "Sumatoria de Juegos",
    groups: "Grupos",
    elimination: "Eliminación",
    final: "Final",
    myGroup: "Mi Grupo",
    participants: "Participantes",
    backToGroups: "← Volver a Grupos",
    scheduled: "Programado",
    inProgress: "En Juego",
    completed: "Completado",
    unknown: "Desconocido",
    champion: "¡Campeón del Torneo!",
    congratulations: "¡Felicidades!",
    you: "Tú",
    yourTeam: "Tu equipo",
    accessCodeQuestion: "¿Tienes un código de acceso?",
    signMeUp: "¡Inscríbeme!",
    loading: "Cargando...",
    scheduledMatches: "partidos programados",
    noMatchesFound: "No se encontraron partidos asignados.",
    matchesComingSoon: "Los partidos serán programados próximamente.",
    groupNotAssigned: "Grupo no asignado",
    groupAssignSoon: "El organizador asignará tu grupo próximamente.",
    myGroupStandings: "Mi Grupo - Clasificación",
    groupStandings: "Clasificación del Grupo",
    position: "Posición",
    pos: "Pos.",
    team: "Equipo",
    pair: "Pareja",
    sets: "Sets",
    games: "Juegos",
    pts: "Pts",
    diff: "Dif.",
    court: "Cancha",
    contactOrganizer: "Contactar organizador",
    classifiedForElimination: "Clasificados para Eliminación",
    waitingGroupPhase: "Esperando a que finalicen todos los partidos de la fase de grupos",
    waitingGroupPhaseDesc: "Una vez completados, aquí aparecerá el ranking de clasificados a la fase eliminatoria.",
    firstPlace: "1er Lugar",
    secondPlace: "2do Lugar",
    wildcard: "Wildcard",
    registeredParticipants: "Participantes Inscritos",
    category: "Categoría",
    subcategory: "Subcategoría",
    noParticipants: "No hay participantes inscritos en esta subcategoría",
    loadingParticipants: "Cargando participantes...",
    pairs: "parejas",
    singlePair: "pareja",
    matches: "partidos",
    match: "partido",
    octavos: "Octavos de Final",
    cuartos: "Cuartos de Final",
    semifinales: "Semifinales",
    finished: "Finalizado",
    finalized: "✓ Finalizado",
    championLabel: "⭐ CAMPEÓN ⭐",
    classify: "Clasifican",
    classificationTBD: "Clasificación por definir",
    firstPlaces: "primeros lugares",
    bestSeconds: "mejores 2dos",
    bestThirds: "mejores 3eros",
    bestFourths: "mejores 4tos",
    teams: "equipos",
    structure: "Estructura",
    preparingTournament: "Preparando Tu Torneo",
    groupsAssignedSoon: "Los grupos se asignarán pronto. ¡Mantente atento a las notificaciones!",
    notAssignedToGroup: "Aún no has sido asignado a un grupo",
    allGroups: "Todos los Grupos",
    eliminationPhaseTab: "Fase de Eliminación",
    active: "En Curso",
    upcoming: "Próximo",
    goToMatch: "Ir al partido",
    groupPrefix: "Grupo",
    toBeAssigned: "Por asignar",
    back: "← Volver",
    matchSchedulesSoon: "Los horarios de los partidos se publicarán próximamente",
    linkCopied: "Enlace copiado al portapapeles",
    joinTournament: "¡Únete al",
    registerToSeeDetails: "Regístrate para Ver Detalles",
    registerToSeeDetailsMsg: "Inscríbete en este torneo para ver grupos y partidos",
    pendingMatch: "Partido Programado",
    rankingTable: "Tabla de Posiciones",
    eliminationBracket: "Bracket de Eliminación",
    eliminationDirectBracket: "Bracket de Eliminación Directa",
    tournamentMatches: "Partidos del Torneo",
    groupMatches: "Partidos del Grupo",
    classificationByGames: "Clasificación por Juegos",
    groupPositions: "Tabla de Posiciones del Grupo",
    toBeConfirmed: "Por confirmar",
    matchupsConfirmedOnStart: "Los emparejamientos se confirmarán cuando inicie el evento",
    participant: "Participante",
    viewParticipants: "Ver participantes",
    viewBrackets: "Ver Brackets",
    positionsUpdatedOnPlay: "Las posiciones se actualizarán conforme se jueguen los partidos",
    toBeDecided: "Por definir",
    participantsToBeDecided: "Por definir participantes",
    bracketGeneratedOnConfirm: "El bracket se generará automáticamente una vez que se confirmen todos los participantes",
    datesToBeConfirmed: "Fechas por confirmar",
    matchSchedulesPublished: "Los enfrentamientos y horarios se publicarán antes del inicio del torneo",
    roundRobin: "Round Robin",
    matchesPlayed: "PJ",
    wins: "G",
    losses: "P",
    goToMatchLabel: "Ir al partido",
    prizes: "Premios",
    rules: "Reglas",
    tournamentRules: "Reglas del Torneo",
    categoryLabel: "Categoría",
    stageLabel: "Etapa",
    partnerLabel: "Compañero",
    notSpecified: "No especificado",
    statusUpcoming: "Próximo",
    activeTournament: "Torneo Activo",
    accessCode: "Código de acceso",
    gameRulesGroupPhase: "Reglas de Juego - Fase de Grupos",
    gameRulesEliminationPhase: "Reglas de Juego - Fase de Eliminación",
    gameRulesFlashTournament: "Reglas de Juego - Torneo Relámpago",
    gameRulesPickleballTournament: "Reglas de Juego - Torneo Pickleball",
    gameRulesSumOfGames: "Reglas de Juego - Sumatoria de Juegos",
    formatBestOf: "Formato: Mejor de",
    formatSingleSet: "Formato: A un solo set",
    gamesPerSet: "Juegos por set",
    goldenPoint: "Punto de Oro",
    superTieBreak: "Super Tie-Break",
    yesApplies: "Sí, se aplica",
    noApplies: "No se aplica",
    eliminationLoserOut: "Eliminación directa: El perdedor queda eliminado",
    classificationByTotalGames: "Clasificación: Por total de juegos ganados en todas las rondas",
    timingSection: "Tiempos",
    warmup: "Calentamiento",
    minutes: "minutos",
    restBetweenSets: "Descanso entre sets",
    minuteParens: "minuto(s)",
    sideChange: "Cambio de lado",
    conductSection: "Conducta y Tolerancia",
    conductOnly: "Conducta",
    arrivalTolerance: "Tolerancia de llegada",
    doubleElimination: "Eliminación Doble",
    loadingRules: "Cargando reglas...",
    noRulesConfigured: "No hay reglas configuradas para este torneo.",
    yourMatches: "Tus Partidos",
    noMatchesForTournament: "No se encontraron partidos programados para este torneo.",
    noGroupMatchesForYou: "No se encontraron partidos de fase de grupos para ti.",
    opponentTBD: "Rival por definir",
    groupClassification: "Clasificación del Grupo",
    noElimMatchesYet: "Aún no hay partidos de fase de eliminación programados.",
    tbd: "Por definir",
    matchesCount: "partidos",
  },
  splitPayment: {
    title: "Pago de inscripción pendiente",
    confirmed: "¡Inscripción confirmada!",
    bothPaid: "Ambos pagos fueron procesados exitosamente. ¡Nos vemos en el evento!",
    expired: "El tiempo para completar el pago ha expirado. El cargo fue liberado.",
    remaining: "restantes para pagar",
    invitedBy: "Invitado por",
    yourAmount: "Tu parte",
    payNow: "Pagar ahora",
    processing: "Procesando...",
    paymentConfirmed: "¡Pago confirmado! La inscripción está completa.",
    paymentCancelled: "El pago fue cancelado. Puedes intentar de nuevo.",
    notFound: "Pago no encontrado",
    loginRequired: "Inicia sesión para continuar",
    loginToPayDesc: "Necesitas iniciar sesión para completar tu pago de inscripción.",
    errorCreatingPayment: "Error al crear la sesión de pago",
  },
};
